import DashboardTwoCharts from "./chart";
import RecentActivity from "./recent.activity";
import State from "./state";

const HomeHero = () => {
  return (
    <main class="w-[96%] mx-auto mt-6">
      <State />
      <DashboardTwoCharts />
      <RecentActivity />
    </main>
  );
};

export default HomeHero;
